"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M23 3H1v18h22zm-11 8H3V9h9zm0-4H3V5h9z"
}), 'FeaturedPlayListSharp');